import { ts } from '_core';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.ALPHA_MODEL_OPTIMIZED_BIAS_STATISTIC,
    title: 'Factor Portfolio Bias Statistics',
    helpLabel: 'oejoflyr',
    form: false,
    neededFiles: ['optimized_alpha_model_bias_statistics'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.OPTIMIZED_ALPHA_MODEL],
  },
] satisfies ts.types.analysis.WidgetConfig[];
